(function () {
  var root = document.querySelector('[data-town-blog]');
  if (!root) return;

  var cards = Array.prototype.slice.call(root.querySelectorAll('[data-topic]'));
  var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-topic-filter]'));
  var empty = root.querySelector('[data-town-empty]');

  function apply(topic) {
    var shown = 0;
    cards.forEach(function (card) {
      var on = topic === 'all' || card.getAttribute('data-topic') === topic;
      card.hidden = !on;
      if (on) shown += 1;
    });
    buttons.forEach(function (button) {
      button.setAttribute('aria-pressed', button.getAttribute('data-topic-filter') === topic ? 'true' : 'false');
    });
    if (empty) empty.hidden = shown !== 0;
    var next = topic === 'all' ? location.pathname + location.search : location.pathname + location.search + '#' + topic;
    if (location.pathname + location.search + location.hash !== next) {
      history.replaceState(null, '', next);
    }
  }

  buttons.forEach(function (button) {
    button.addEventListener('click', function () {
      apply(button.getAttribute('data-topic-filter'));
    });
  });

  var hash = (location.hash || '').replace('#', '');
  var known = buttons.some(function (button) {
    return button.getAttribute('data-topic-filter') === hash;
  });
  apply(known ? hash : 'all');
})();

(function () {
  var article = document.querySelector('.town-article .post-content');
  var slot = document.querySelector('[data-town-toc]');
  var wrap = document.querySelector('[data-town-toc-wrap]');
  if (!article || !slot || !wrap) return;

  var heads = Array.prototype.slice.call(article.querySelectorAll('h2, h3, h4, h5, h6'));
  if (!heads.length) return;

  function slug(text, index) {
    var base = (text || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    return (base || 'section') + '-' + index;
  }

  heads.forEach(function (heading, index) {
    if (!heading.id) heading.id = slug(heading.textContent, index);
  });

  var root = document.createElement('ol');
  var stack = [{ level: 1, list: root }];

  heads.forEach(function (heading) {
    var level = parseInt(heading.tagName.slice(1), 10);
    while (stack.length > 1 && stack[stack.length - 1].level >= level) stack.pop();
    var item = document.createElement('li');
    var link = document.createElement('a');
    link.href = '#' + heading.id;
    link.setAttribute('data-toc', heading.id);
    link.textContent = heading.textContent.replace(/\s+/g, ' ').trim();
    item.appendChild(link);
    var nested = document.createElement('ol');
    item.appendChild(nested);
    stack[stack.length - 1].list.appendChild(item);
    stack.push({ level: level, list: nested });
  });

  root.querySelectorAll('ol').forEach(function (list) {
    if (!list.children.length) list.remove();
  });

  slot.appendChild(root);
  wrap.hidden = false;

  var links = Array.prototype.slice.call(slot.querySelectorAll('a[data-toc]'));
  function mark(id) {
    links.forEach(function (link) {
      var on = link.getAttribute('data-toc') === id;
      if (on) link.setAttribute('aria-current', 'true');
      else link.removeAttribute('aria-current');
    });
    var current = slot.querySelector('[aria-current="true"]');
    var rail = document.querySelector('.town-article__side');
    if (!current || !rail || rail.scrollHeight <= rail.clientHeight) return;
    var railBox = rail.getBoundingClientRect();
    var linkBox = current.getBoundingClientRect();
    if (linkBox.top < railBox.top + 8 || linkBox.bottom > railBox.bottom - 8) {
      rail.scrollTop += linkBox.top - railBox.top - 28;
    }
  }

  function currentId() {
    var id = heads[0].id;
    heads.forEach(function (heading) {
      if (heading.getBoundingClientRect().top <= 110) id = heading.id;
    });
    return id;
  }

  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      mark(currentId());
    });
  }, { passive: true });
  mark(currentId());

  links.forEach(function (link) {
    link.addEventListener('click', function (event) {
      var target = document.getElementById(link.getAttribute('data-toc'));
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      history.replaceState(null, '', '#' + target.id);
      mark(target.id);
    });
  });
})();
